<div class="row">
  <div class="col s3 margin-top">
    <div class="row">
      <h4 class="h4 chart-title chart-title--thin margin-none padding-top_half">
        {{ 'groups.dashboard.status' | translate }}
        <gl-tooltip posBottom [text]="tooltipText"></gl-tooltip>
      </h4>
    </div>
    <div class="row">
      <lms-licenses-totals-widget
        [totals]="totals"
        [data]="data"
        [key]="'studentsProgress'"
      ></lms-licenses-totals-widget>
    </div>
  </div>

  <div class="col s9 margin-top">
    <lms-recent-activity-widget
      [data]="data"
      [keys]="{ recentActivity: 'recentActivity', connected: 'connected', averageDuration: 'averageDuration' }"
    ></lms-recent-activity-widget>
  </div>
</div>
